<template>
  <span>
    <b-card no-body>
      <b-card-header>
        <b-row>
          <b-col sm="10">
            <h3>Cadastro de Programas do Município</h3>
          </b-col>
        </b-row>
      </b-card-header>
      <b-card-body>
        <b-form v-on:submit.prevent="onSubmit">
          <b-row>
            <b-col cols="6">
              <b-form-group label="Ativo? *">
                <b-input-group class="mb-6">
                  <b-form-select
                    v-model="$v.form.ativo.$model"
                    :state="chkState('ativo')"
                    class="mb-3"
                  >
                    <option selected :value="null">Selecione</option>
                    <option selected :value="true">Sim</option>
                    <option selected :value="false">Não</option>
                  </b-form-select>
                  <b-form-invalid-feedback id="input1LiveFeedback6"
                    >Ativação é obrigatória.</b-form-invalid-feedback
                  >
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <b-form-group label="Nome: *">
                <b-input-group class="mb-6">
                  <b-input-group-prepend>
                    <b-input-group-text
                      ><i class="icon-user"></i
                    ></b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input
                    type="text"
                    class="form-control"
                    placeholder="Nome do programa"
                    v-model="$v.form.nome.$model"
                    :state="chkState('nome')  && tituloValid"
                    autofocus
                  />
                  <b-form-invalid-feedback id="input1LiveFeedback1" :state="chkState('nome') && tituloValid"
                    >{{ msgTituloValid}}</b-form-invalid-feedback
                  >
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <div cols="12">
            <label>Texto de descrição: *</label>
            <b-form-textarea
              value="Hello, World!"
              v-model="$v.form.texto.$model"
              placeholder="Escreva a descrição aqui..."
              rows="3"
              max-rows="6"
            ></b-form-textarea>
            <b-form-invalid-feedback :state="descricaoValid"
              >{{ msgDescricaoValid }}</b-form-invalid-feedback
            >
          </div>
          <b-row>
            <b-col cols="12">
              <br />
              <label>Imagem: *</label>
              <span
                class="icon-info"
                v-b-popover.hover.top="'Permitidos somente imagens'"
                title="Programas"
              ></span>
              <b-form-group
                label-for="nome-input"
                invalid-feedback="Imagem é obrigatório"
              >
                <b-row>
                  <b-col cols="11">
                    <b-form-file
                      ref="file-input"
                      browse-text="Selecione"
                      placeholder="Selecione o documento"
                      v-on:change="uploadDoc"
                      :state="chkState('imagem')"
                    ></b-form-file>
                  </b-col>
                  <b-col cols="1">
                    <a
                      class="btn btn-md btn-secondary action"
                      title="Deletar imagem"
                      v-on:click="clearFiles"
                    >
                      <i class="icon-trash"></i>
                    </a>
                  </b-col>
                </b-row>
                <b-form-invalid-feedback
                  id="input1LiveFeedback3"
                  :state="chkState('imagem')"
                  >Imagem é obrigatório.</b-form-invalid-feedback
                >
              </b-form-group>
            </b-col>
            <b-col v-if="imagemAtual" cols="12">
              <label>Capa atual:</label>
              <div class="image-preview">
                <img class="preview" :src="imagemAtual" />
                <br /><br />
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <b-form-group label="Link: *">
                <b-input-group class="mb-6">
                  <b-input-group-prepend>
                    <b-input-group-text
                      ><i class="icon-link"></i
                    ></b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input
                    type="text"
                    class="form-control"
                    placeholder="Link do programa"
                    v-model="$v.form.link.$model"
                    :state="chkState('link')"
                    autofocus
                  />
                  <b-form-invalid-feedback id="input1LiveFeedback1"
                    >Link é obrigatório.</b-form-invalid-feedback
                  >
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="6">
              <b-form-group label="Data Início: ">
                <b-input-group class="mb-6">
                  <b-form-input
                    type="date"
                    class="form-control"
                    placeholder="Data Início do programa"
                    v-model="$v.form.dataInicio.$model"
                    :state="chkState('dataInicio')"
                    autofocus
                  />
                  <b-form-invalid-feedback id="input1LiveFeedback1"
                    >Data Início é obrigatório.</b-form-invalid-feedback
                  >
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group label="Data Fim: ">
                <b-input-group class="mb-6">
                  <b-form-input
                    type="date"
                    class="form-control"
                    placeholder="Data Fim do programa"
                    v-model="$v.form.dataFim.$model"
                    :state="chkState('dataFim')"
                    autofocus
                  />
                  <b-form-invalid-feedback id="input1LiveFeedback1"
                    >Data Fim é obrigatório.</b-form-invalid-feedback
                  >
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
        </b-form>
      </b-card-body>
      <b-card-footer class="p-12">
        <b-row>
          <b-col md="3" offset-md="3">
            <b-button block variant="primary" v-on:click="onSubmit">
              <i class="fa fa-check"></i>&nbsp;
              <span>Salvar Programa</span>
            </b-button>
          </b-col>
          <b-col md="3">
            <b-button block variant="secondary" @click="$router.go(-1)">
              <i class="fa fa-mail-reply-all"></i>&nbsp;&nbsp;<span
                >Voltar</span
              >
            </b-button>
          </b-col>
        </b-row>
      </b-card-footer>
    </b-card>
  </span>
</template>

<script>
import 'v-markdown-editor/dist/v-markdown-editor.css'
import Vue from 'vue'
import AuthTemplate from '@/templates/auth/AuthTemplate'
import VueSelect from 'vue-select'
import { validationMixin } from 'vuelidate'
import { required, requiredIf } from 'vuelidate/lib/validators'
import miniToastr from 'mini-toastr'
import Editor from 'v-markdown-editor'
import CKEditor from 'ckeditor4-vue'
import SessionStorage from '@/services/session-storage'

miniToastr.init()
Vue.use(Editor)
Vue.use(CKEditor)

const formShape = {
  nome: '',
  texto: '',
  imagem: '',
  ativo: null,
  link: '',
  dataInicio: null,
  dataFim: null
}

export default {
  name: 'Cadastro',
  components: {
    AuthTemplate,
    VueSelect,
    Editor
  },
  mixins: [validationMixin],
  validations: {
    form: {
      nome: {
        required
      },
      texto: {
        // required
      },
      municipio_id: {
        required
      },
      ativo: {
        required
      },
      link: {
        required
      },
      dataInicio: {
        // required
      },
      dataFim: {
        // required
      },
      imagem: {
        required: requiredIf(function (nestedModel) {
          return !this.imagemAtual
        })
      }
    }
  },
  created () {
    if (
      SessionStorage.get('tipoPerfil').replace(/['"]+/g, '') === 'P' ||
      SessionStorage.get('tipoPerfil').replace(/['"]+/g, '') === 'L'
    ) {
      this.$store.dispatch('buscarMunicipiosProgramas')
      this.$store.dispatch('getUsuario', SessionStorage.get('usuario'))
    } else {
      this.$router.push('/')
    }
  },
  data () {
    return {
      form: Object.assign({}, formShape),
      id: 0,
      imagemAtual: false,
      descricaoValid: '',
      msgDescricaoValid: '',
      tituloValid: true,
      msgTituloValid: 'Campo nome é obrigatorio',
      DeleteImagens: false,
      disabled_cidades: true,
      uf: null,
      editorConfig: {
        removePlugins: 'elementspath,resize'
      }
    }
  },
  mounted () {
    if (typeof this.$route.params.id !== 'undefined') {
      this.loadPrograma(this.$route.params.id)
    }
  },
  computed: {
    isValid () {
      return !this.$v.form.$anyError
    },
    estados () {
      return this.$store.state.estado.listaEstados
    },
    cidades () {
      return this.$store.state.cidade.listaCidadesPorEstado
    },
    municipiosprogramas () {
      return this.$store.state.municipiosprogramas.listaMunicipiosProgramas
    },
    usuario () {
      return this.$store.state.usuario.usuarioEditar
    }
  },
  watch: {
    'usuario.dados_pessoais': function () {
      this.$v.form.municipio_id.$model =
        this.usuario.dados_pessoais.municipio_atuacao_id
    }
  },
  methods: {
    salvar () {
      var form = this.$v.form

      this.municipiosprogramas.forEach((element) => {
        if (element.municipio_id === form.municipio_id.$model) {
          this.uf = element.uf_id
        }
      })

      let data = {
        id: this.id,
        imagem_capa: form.imagem.$model,
        texto: form.texto.$model,
        nome: form.nome.$model,
        municipio_id: form.municipio_id.$model,
        link: form.link.$model,
        data_inicio: form.dataInicio.$model,
        data_fim: form.dataFim.$model,
        ativo: form.ativo.$model,
        uf_id: this.uf,
        delete_imagem: this.DeleteImagens
      }

      Vue.http
        .post('api/programaDeMunicipios', data)
        .then((response) => {
          if (response.body.success) {
            miniToastr.setIcon('success', 'i', { class: 'fa fa-check' })
            if (this.cadastroInterno) {
              miniToastr.success(
                'Programa salvo com sucesso!',
                'Sucesso!',
                7000
              )
            } else {
              miniToastr.success(response.body.msg, 'Sucesso!', 7000)
            }

            this.$router.push({ path: '/programas-municipios' })
          } else {
            this.disable_buttons = false
            miniToastr.setIcon('error', 'i', { class: 'fa fa-warning' })
            miniToastr.error(response.body.msg, 'Alerta', 5000)
          }
        })
        .catch((e) => {
          console.log('Servidor está fora! ' + e)
        })
    },
    loadPrograma (id) {
      Vue.http.get('api/programaDeMunicipios/' + id).then((response) => {
        this.form.nome = response.body.data.nome
        this.form.texto = response.body.data.texto
        this.form.dataInicio = new Date(response.body.data.data_inicio)
          .toISOString()
          .slice(0, 10)
        this.form.municipio_id = response.body.data.municipio_id
        this.form.dataFim = new Date(response.body.data.data_fim)
          .toISOString()
          .slice(0, 10)
        this.form.link = response.body.data.link
        this.form.ativo = response.body.data.ativo
        this.form.uf_id = response.body.data.uf_id
        this.imagemAtual = response.body.data.imagem_capa
        this.id = response.body.data.id
      })
    },
    clearFiles () {
      this.$refs['file-input'].reset()
      this.$v.form.imagem.$model = null
      this.imagemAtual = null
      this.DeleteImagens = true
    },
    uploadDoc (evento) {
      let arquivo = evento.target.files || evento.dataTransfer.files

      if (!arquivo.length) {
        return false
      }

      let reader = new FileReader()

      reader.onload = (evento) => {
        this.$v.form.imagem.$model = evento.target.result
      }
      reader.readAsDataURL(arquivo[0])
    },
    confirmar () {
      this.$bvModal
        .msgBoxConfirm('Tem certeza que deseja continuar?', {
          okTitle: 'Confirmar',
          cancelTitle: 'Cancelar'
        })
        .then((valor) => {
          if (valor) {
            this.salvar()
          }
        })
        .catch((erro) => {
          console.log(erro)
        })
    },
    onSubmit () {
      if (this.validate()) {
        this.confirmar()
      }
    },
    chkState (val) {
      const field = this.$v.form[val]
      return !field.$dirty || !field.$invalid
    },
    findFirstError (component = this) {
      if (component.state === false) {
        if (component.$refs.input) {
          component.$refs.input.focus()
          return true
        }
        if (component.$refs.check) {
          component.$refs.check.focus()
          return true
        }
      }
      let focused = false
      component.$children.some((child) => {
        focused = this.findFirstError(child)
        return focused
      })

      return focused
    },
    validate () {
      this.msgTituloValid = 'Campo nome é obrigatório.'
      this.$v.$touch()
      this.$nextTick(() => this.findFirstError())

      if (this.$v.form.texto.$model === '') {
        this.descricaoValid = false
        this.msgDescricaoValid = 'O campo descrição é obrigatório.'
        return false
      } else if (this.$v.form.texto.$model.length > 200) {
        this.descricaoValid = false
        this.msgDescricaoValid = 'Limite de 200 caracteres.'
        return false
      } else { this.descricaoValid = true }

      if (this.$v.form.nome.$model.length > 200) {
        this.tituloValid = false
        this.msgTituloValid = 'Limite de 200 caracteres.'
        return false
      } else { this.tituloValid = true }

      return this.isValid
    },
    navigate (route) {
      this.$router.push(route)
    }
  }
}
</script>

<style scoped>
img.preview {
  width: 200px;
  background-color: white;
  border: 1px solid #ddd;
  padding: 5px;
}
</style>



// WEBPACK FOOTER //
// src/pages/site/interna/administrador/programaMunicipio/programaMunicipioFormGestor.vue